import React, { useEffect } from 'react';
import { StickyHeader } from './components/StickyHeader';
import { Hero } from './components/Hero';
import { ProblemBlock } from './components/ProblemBlock';
import { SocialProofBar } from './components/SocialProofBar';
import { BenefitsSection } from './components/BenefitsSection';
import { HowItWorks } from './components/HowItWorks';
import { ProductIntro } from './components/ProductIntro';
import { WorkbooksSection } from './components/WorkbooksSection';
import { BonusesSection } from './components/BonusesSection';
import { TargetLevelsSection } from './components/TargetLevelsSection';
import { VisualApproachSection } from './components/VisualApproachSection';
import { ValueStack } from './components/ValueStack';
import { AudienceSection } from './components/AudienceSection';
import { Testimonials } from './components/Testimonials';
import { Guarantee } from './components/Guarantee';
import { ClosingBlock } from './components/ClosingBlock';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { SocialProofPopup } from './components/SocialProofPopup';
import { FloatingCTA } from './components/FloatingCTA';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  useEffect(() => {
    document.title = 'CHIMIE VISUELLE™ | Bibliothèque de ressources de chimie prêtes à l’emploi';
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute('content', 'CHIMIE VISUELLE™ est une bibliothèque pédagogique très visuelle pour les professeurs de physique-chimie : 5 volumes pédagogiques et 4 ressources complémentaires, soit 460 pages de schémas, fiches, activités, évaluations et corrigés prêts à imprimer ou à projeter. Paiement unique de 19 €, accès numérique immédiat et accès à vie.');
  }, []);
  return <div className="w-full bg-paper text-ink" data-id="element-0" data-mp="3uct25gan0gyw">
      <MetaPixel data-id="element-1" data-mp="3ubzrw5cgz9c0" />
      <StickyHeader data-id="element-2" data-mp="3ucjcjtti8btq" />
      <main data-id="element-3" data-mp="3uf5gljh6s977">
        <span id="hero-sentinel" aria-hidden="true" data-id="element-4" data-mp="d4e6dvbvvgxr" />
        <Hero data-id="element-5" data-mp="d45uo6rhyho5" />
        <ProblemBlock data-id="element-6" data-mp="d2l8p5j9071w" />
        <SocialProofBar data-id="element-7" data-mp="85l0anyxes7m" />
        <BenefitsSection data-id="element-8" data-mp="85bd1859mz5m" />
        <HowItWorks data-id="element-9" data-mp="864b7kq5sgc5" />
        <ProductIntro data-id="element-10" data-mp="83i0xdbvvmq8" />
        <WorkbooksSection data-id="element-11" data-mp="3gl4t5lvoq8m5" />
        <BonusesSection data-id="element-12" data-mp="3gmfw5jhb3cc7" />
        <TargetLevelsSection data-id="element-13" data-mp="3glwabrojc3sw" />
        <VisualApproachSection data-id="element-14" data-mp="3gj1w4hw47f7x" />
        <ValueStack data-id="element-15" data-mp="3bn2ye3owckuu" />
        <AudienceSection data-id="element-16" data-mp="3bnmerfywf16r" />
        <Testimonials data-id="element-17" data-mp="3bk718hkvi07g" />
        <Guarantee data-id="element-18" data-mp="3qb7lrkyw9kjy" />
        <ClosingBlock data-id="element-19" data-mp="3qbfx38fdcht1" />
        <FAQ data-id="element-20" data-mp="3qbzf0p50r672" />
        <Footer data-id="element-21" data-mp="3qciln9p7y85s" />
        <div className="h-[54px] md:hidden" aria-hidden="true" data-id="element-22" data-mp="3qd0s0z5li2rf" />
        <SocialProofPopup data-id="element-23" data-mp="3ljpjmtl4xdxe" />
        <FloatingCTA data-id="element-24" data-mp="3lief2rjv8258" />
      </main>
    </div>;
}